import React from "react";
import moment from "moment";
import Select from "react-select";
import styled from "styled-components";
import { color, spacing } from "@conserveit/blocks";
import { getPreviousMonths } from "../../../utils/time";
import { MonthYear } from "../index";

const monthOptions = getPreviousMonths(11).map((month) => ({
  label: `${month.month}`,
  value: month.timestamp,
}));

const MonthSelect = styled(Select)`
  display: inline-block;
  margin: 0 ${spacing.extraTight};
  width: 160px;
  font-size: 12px;
  font-weight: bold;
  text-transform: uppercase;
  color: ${color.theme.typography.ink};
`;

const SiteSelect = styled(MonthSelect)`
  width: 250px;
`;

const Container = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: center;
  margin-bottom: 16px;
`;

interface Props {
  onMonthChange: ({ value }: { value: moment.Moment }) => void;
  monthValue: MonthYear;
  onSiteChange: ({ value }: { value: string }) => void;
  siteOptions: Array<{ [key: string]: string }>;
  siteValue: { [key: string]: string };
}
const SiteMonthSelect: React.FC<Props> = ({
  onMonthChange,
  onSiteChange,
  monthValue,
  siteValue,
  siteOptions,
}) => (
  <Container>
    <MonthSelect
      className="t-MonthSelect"
      options={monthOptions}
      // styled() drops react-select's option generics; these selects are
      // single-value and not clearable, so an option is always passed.
      onChange={(option) => onMonthChange(option as { value: moment.Moment })}
      placeholder={monthValue.month}
      value={
        monthOptions.find((option) =>
          option.value.isSame(monthValue.timestamp, "month")
        ) || null
      }
    />
    <SiteSelect
      options={siteOptions}
      onChange={(option) => onSiteChange(option as { value: string })}
      placeholder={siteValue.label}
      value={siteValue}
    />
  </Container>
);

export default SiteMonthSelect;
